console.log("Budget Engine Loaded");

function detectBudget(message){

    message = message.toLowerCase();

    //------------------------------------
    // Extract all numbers
    //------------------------------------

    const numbers = message.match(/\d+/g);

    if(!numbers){

        return null;

    }

    const amount = parseInt(numbers[0]);

    //------------------------------------
    // Under / Below
    //------------------------------------

    if(
        message.includes("under") ||
        message.includes("below") ||
        message.includes("less than")
    ){

        return {

            type: "MAX",

            amount: amount

        };

    }

    //------------------------------------
    // Above
    //------------------------------------

    if(
        message.includes("above") ||
        message.includes("more than") ||
        message.includes("greater than")
    ){

        return {

            type: "MIN",

            amount: amount

        };

    }

    //------------------------------------
    // Around / Budget
    //------------------------------------

    if(
        message.includes("budget") ||
        message.includes("around") ||
        message.includes("approx")
    ){

        return {

            type: "TARGET",

            amount: amount

        };

    }

    return null;

}

function filterProductsByBudget(products, budget){

    if(!budget){

        return products;

    }

    return products.filter(product=>{

        const price = parseFloat(product.variants[0].price);

        switch(budget.type){

            case "MAX":

                return price <= budget.amount;

            case "MIN":

                return price >= budget.amount;

            case "TARGET":

                return Math.abs(price - budget.amount) <= 1000;

            default:

                return true;

        }

    });

}